import ReactGA from "react-ga4";
import getConfig from 'next/config'

const { publicRuntimeConfig: { GA_CODE } } = getConfig();

function getUserId(user) {
    if (user && user.vendedor) {
        return user.vendedor.nombre;
    } else if (user && user.cliente) {
        return user.cliente.nombre;
    } else if (user && user.username) {
        return user.username;
    }
    return null;
}

const initializeGoogleAnalytics = (user) => {
    const user_id = getUserId(user);

    ReactGA.initialize(GA_CODE, {
        gaOptions: {
            debug_mode: true,
            user_id,
            iturriaUser: user_id,
            role: user && user.role ? user.role.name : null
            }
        }
    );

    ReactGA.send({ hitType: 'pageview', page: window.location.pathname + window.location.search });
}

// GA4 standard "item_list_name" for an event originated from somewhere other than a plain
// catalog browse (e.g. a suggested-product banner, a deal, favorites). `attribution` is
// whatever object the caller has on hand (redux itemDetail, a query param bag, etc.) —
// only its `source`/`displayLocation` fields are read, so callers don't need to build a
// special-shaped object just to report where the event came from.
const buildItemListName = ({ source, displayLocation } = {}) => {
    if (!source) return undefined;
    return displayLocation ? `suggested_banner_${displayLocation}` : source;
};

const trackAnalyticsCommerceEvent = (
    event_name,
    event_category,
    event_label,
    user,
    value,
    data = [],
    attribution
) => {
    const username = getUserId(user);
    const item_list_name = buildItemListName(attribution);
    const items = item_list_name ? data.map((item) => ({ ...item, item_list_name })) : data;

    let event_params = {
        event_category,
        event_label,
        iturriaUsername: username,
        value,
        currency: 'ARS',
        items
    };
    // Send GA4 Event

    ReactGA.event(event_name, event_params);
};

const trackDownloadEvent = (
    format
) => {
    let event_params = {
        eventCategory: "Price List",
        eventLabel: "Download Price List",
        currency: 'ARS',
        format
    };
    ReactGA.event('downloadPriceList', event_params);
};

export default initializeGoogleAnalytics;
export { initializeGoogleAnalytics, trackAnalyticsCommerceEvent, trackDownloadEvent, buildItemListName };


